import { Navigate } from 'react-router-dom';
import useAuthStore from '@/stores/authStore';
import Spinner from '@components/Spinner';

/**
 * AdminRoute — only users with role === 'admin' can access.
 * Redirects to /login if not authenticated, to / if authenticated but not admin.
 */
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuthStore();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
